import { keysToCamelCase, removeUndefinedValues } from '../../../utils/object';
import getVideoDuration from '../../../utils/get-video-duration';
import { convertSSToMMSS } from '../../../utils/time';

import transcodingStatuses from '../../../constants/transcoding-statuses';
import videoSources from '../../../constants/video-sources';
import freeDealInfo from '../../../constants/free-deal-info';


export default function parseVideo(videoData, settings) {

  if (!videoData) {
    return null;
  }

  videoData = keysToCamelCase(videoData);

  const {
    id,
    format,
    embedHtml,
    description,
    from: { name: publisher },
    name,
    title = name || description || publisher,
    source,
  } = videoData;

  const externalId = String(id);

  let coverUrl;
  if (format) {
    coverUrl = _.find(format, { filter: 'native' }).picture.replace(/^https?:/, '');
  }

  const width = embedHtml && Number(embedHtml.match(/width="(\d+)/)[1]);
  const height = embedHtml && Number(embedHtml.match(/height="(\d+)/)[1]);

  const mediaExternUrl = `//www.facebook.com/video.php?v=${externalId}`;

  // no source for live videos
  const durationPromise = source ?
    getVideoDuration(source, settings, { skipProbe: true }) :
    Promise.resolve(0);

  return durationPromise
    .then(function (duration) {
      const durationSec = Math.round(duration / 1000);
      const durationStr = convertSSToMMSS(durationSec);

      return removeUndefinedValues({
        externalId,
        coverUrl,
        width,
        height,
        description,
        publisher,
        title,
        mediaExternUrl,
        mediaStatus: transcodingStatuses.READY,
        dealInfo: freeDealInfo,
        durationSec,
        durationStr,
        videoSource: videoSources.FACEBOOK,
      });
    });
}



// WEBPACK FOOTER //
// ./src/transport/adapters/facebook/parsers/video.js